import React from 'react'
import parse, { DOMNode, Element } from 'html-react-parser'
import { Script } from './Script'
import EntryForm from './EntryForm'
import { FormForSalesforceScript } from './Formstack'
import ConvertLeadForm from './ConvertLeadForm'
import ChiliPiperForm from './ChiliPiperForm'

/**
 * Embed code module – parses raw HTML and emits JSX elements,
 * and replaces any known, safe SCRIPT tags with our Script component.
 */

interface Props {
  fragment: string
}

function isTypeform (src: string): boolean {
  return src.startsWith('//embed.typeform.com/')
}

function isCalendly (src: string): boolean {
  return src.startsWith('https://assets.calendly.com/')
}

function isChiliPiper (src: string): boolean {
  return src.startsWith('https://rula.chilipiper.com/')
}

function isOurSalesforce (src: string): boolean {
  return (src.startsWith('https://mentalhealth.secure.force.com/') || src.startsWith('https://pathccm.my.salesforce-sites.com/'))
}

function isOurSalesforceStaging (src: string): boolean {
  return src.startsWith('https://pathccm--staging.sandbox.my.salesforce-sites.com/')
}

function replacer (domNode: DOMNode): JSX.Element | void {
  if (domNode instanceof Element && domNode.name === 'script') {
    const { id, src } = domNode.attribs

    if (id === 'jsFastForms' && (isOurSalesforce(src) || isOurSalesforceStaging(src))) {
      return <FormForSalesforceScript src={src} />
    } else if (isTypeform(src) || isCalendly(src)) {
      return <Script src={src} />
    } else if (isChiliPiper(src)) {
      return <ChiliPiperForm src={src} />
    } else if (id === 'entry-form') {
      return <EntryForm src={src} />
    } else if (id === 'convert-lead-form') {
      return <ConvertLeadForm src={src} />
    } else {
      return <></> /* not recognized */
    }
  }
}

export const EmbedCode: React.FC<Props> = ({ fragment }) => {
  return <>{ parse(fragment, { replace: replacer }) }</>
}
